import React from 'react'
import { Pencil } from 'lucide-react'
import { Button } from '@/components/ui/button'
import EditCustomer from './edit'
import Modal from '../../modal'

class Customer extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      editing: false
    }

    this.onToggleEdit = this.onToggleEdit.bind(this)
    this.onDone = this.onDone.bind(this)
  }

  onToggleEdit(e) {
    if (e) {
      e.preventDefault()
    }

    this.setState({ editing: !this.state.editing })
  }

  onDone() {
    this.setState({ editing: false })
  }

  render() {
    return (
      <div>
        <div className="flex flex-wrap items-center gap-2">
          <h4 className="font-heading text-xl font-medium leading-tight">
            {this.props.customer.name}
            {this.props.enquiry_customer.relation_to_learner ?
              <span>&nbsp;({this.props.enquiry_customer.relation_to_learner})</span>
              : null
            }
          </h4>
          <Button size="icon-sm" variant="secondary" title="Edit customer" onClick={this.onToggleEdit}><Pencil /></Button>
        </div>
        {this.state.editing ?
          <Modal size="modal-lg" title="Edit Customer" onClose={this.onDone}>
            <div className="p-6">
              <EditCustomer
                key={this.props.enquiry_id}
                enquiry_id={this.props.enquiry_id}
                customer={this.props.customer}
                enquiry_customer={this.props.enquiry_customer}
                onDone={this.onDone}
              />
            </div>
          </Modal>
          : null
        }
      </div>
    )
  }
}

export default Customer
